import AtomicSupport from "../../../../src/courses/partials/atomic/support.mdx";
import * as React from 'react';
export default {
  AtomicSupport,
  React
};